/**
 * Google Analytics & Consent Mode Management Service (AUD-066, Issue #223)
 *
 * Implements account-based consent gating:
 * - Unauthenticated visitors: Cookieless aggregate measurement (analytics_storage: 'denied').
 *   No persistent cookies (_ga, _ga_*) are written or read on the visitor's device.
 * - Authenticated users: Refined analytics storage granted (analytics_storage: 'granted')
 *   upon account sign-in/creation with Terms & Privacy Policy acceptance.
 * - Sign-out: Analytics storage reverted to 'denied' and cookies wiped.
 */

export const setupConsentDefaults = () => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  // Set strict default consent before any Google tag or Firebase Analytics load
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
  });
};

export const clearAnalyticsCookies = () => {
  if (typeof document === 'undefined') return;

  const cookies = document.cookie ? document.cookie.split(';') : [];
  const domain = typeof window !== 'undefined' ? window.location.hostname : '';
  const hostParts = domain ? domain.split('.') : [];
  let baseDomain = '';
  if (hostParts.length > 2) {
    baseDomain = '.' + hostParts.slice(-2).join('.');
  } else if (domain) {
    baseDomain = '.' + domain;
  }

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    if (name === '_ga' || name.startsWith('_ga_')) {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      if (domain) {
        document.cookie = `${name}=; Path=/; Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      }
      if (baseDomain) {
        document.cookie = `${name}=; Path=/; Domain=${baseDomain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      }
    }
  }
};

export const updateAnalyticsConsent = (isAuthenticated) => {
  if (typeof window === 'undefined') return;

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: isAuthenticated ? 'granted' : 'denied'
    });
  }

  if (!isAuthenticated) {
    clearAnalyticsCookies();
  }
};
